import { ServiceDetailPage } from '../../components/ServiceDetailPage';
import { SERVICE_ARTIKULACIOS } from '../../data/content';
import { Helmet } from 'react-helmet-async';

export default function ArticulationPage() {
  return (
    <>
      <Helmet>
        <title>Artikulációs Zavar, Pöszeség Kezelése | Mosolytorna</title>
        <meta name="description" content="A beszédhangok helyes ejtésének kialakítása, pöszeség javítása és artikulációs zavarok kezelése gyermekeknél és felnőtteknél egyaránt." />
      </Helmet>
      
      <ServiceDetailPage service={SERVICE_ARTIKULACIOS} />
    </>
  );
}
